import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Distance',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewbox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M7 13c-3.87 0-7 3.31-7 7.4C0 26.16 7 32 7 32s7-5.84 7-11.6c0-4.09-3.13-7.4-7-7.4zm0 10c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm14.71-10.09c-.62.71-1.08 1.6-1.09 2.54-.01.94.42 1.83.75 2.71.22.58.4 1.19.53 1.8.33 1.6.33 3.26-.19 4.8-.79 2.37-2.73 4.24-4.95 5.38-2.22 1.13-5.06 1.62-7.54 1.86l.01-.01c1.27-1.24 3.22-3.37 4.61-5.9.26-.05.59-.11.81-.17 2.07-.55 3.67-2.53 3.77-4.66.09-1.93-.91-3.84-.51-5.73.27-1.27 1.17-2.34 2.24-3.09.78-.54 1.78-1 2.67-1.36.17.16.33.32.47.45-.53.39-1.15.89-1.58 1.38zM25 0c-2.21 0-4 2.01-4 4.5C21 8 25 11 25 11s4-3 4-6.5C29 2.01 27.21 0 25 0zm0 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" }
      })]
    );
  }
};